/* eslint react/prop-types: 0 */
import React from 'react'
import { Accordion, Card, FormInput, Icon, Select } from 'camino-react'

import AttributesChangedCondition from './AttributesChangedCondition'
import AttributesEqualCondition from './AttributesEqualCondition'
import AttributesMatchCondition from './AttributesMatchCondition'
import MissingAttributeCondition from './MissingAttributeCondition'
import ProblemCondition from './ProblemCondition'
import ResponseCondition from './ResponseCondition'
import ResponseTimeCondition from './ResponseTimeCondition'
import SLACondition from './SLACondition'
import SurveyScoreCondition from './SurveyScoreCondition'

const WorkflowConditions = ({
  conditions,
  setConditions,
  options,
  type
}) => {
  const conditionForTicket = [
    {
      label: 'Attributes Changed',
      value: 'WorkflowConditions::AttributesChanged',
      type: 'Ticket'
    },
    {
      label: 'Equal to Values',
      value: 'WorkflowConditions::AttributesEqual',
      type: 'Ticket'
    },
    {
      label: 'Matching Values',
      value: 'WorkflowConditions::AttributesMatch',
      type: 'Ticket'
    },
    {
      label: 'Missing Attributes',
      value: 'WorkflowConditions::MissingAttribute',
      type: 'Ticket'
    },
    {
      label: 'Assigned to problem?',
      value: 'WorkflowConditions::ProblemTicket',
      type: 'Ticket'
    },
    {
      label: 'No response for',
      value: 'WorkflowConditions::NoResponse',
      type: 'Ticket'
    },
    {
      label: 'Responded',
      value: 'WorkflowConditions::Response',
      type: 'Ticket'
    },
    {
      label: 'SLA',
      value: 'WorkflowConditions::PassedSLA',
      type: 'Ticket'
    },
    {
      label: 'Survey Score',
      value: 'WorkflowConditions::SurveyScore',
      type: 'Ticket'
    }
  ]

  const conditionsForAlert = [
    {
      label: 'Equal to Values',
      value: 'WorkflowConditions::AttributesEqual',
      type: 'Ticket'
    }
  ]

  const addCondition = (conditionType) => {
    setConditions([...conditions, { type: conditionType, predicates: {} }])
  }

  const removeCondition = (conditionType) => {
    setConditions(conditions.filter(condition => condition !== conditionType))
  }

  const update = (condition, key, value) => {
    const newConditions = [...conditions]
    const conditionToUpdate = newConditions.find(c => c === condition)

    if (key === null) conditionToUpdate.predicates = value
    else conditionToUpdate.predicates[key] = value

    setConditions(newConditions)
  }

  return (
    <Card allowOverflow>
      <div className="flex flex-col items-end">
        <div className="w-full">
          {conditions.map(condition => (
            <div className="flex">
              <div className="w-full -mb-px">
                <Accordion>
                  {[{
                    title: <div className="text-left">{condition.description || condition.type.replace('WorkflowConditions::', '')}</div>,
                    content: <Condition condition={condition} update={update} options={options} type={type} />
                  }]}
                </Accordion>
              </div>

              <div className="border-t border-b border-blue-200 -mb-px pr-3 pt-3">
                <button
                  onClick={() => removeCondition(condition)}
                  className="text-3xl text-blue-500 duration-300 cursor-pointer hover:text-blue-700"
                  type="button"
                >
                  <Icon type="trash" />
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="w-full mt-4">
          <FormInput label="Select Condition to add">
            <Select
              options={type === 'Ticket' ? conditionForTicket : conditionsForAlert}
              onChange={e => addCondition(e.value)}
            />
          </FormInput>
        </div>
      </div>
    </Card>
  )
}

export default WorkflowConditions

const Condition = ({ condition, update, options, type }) => {
  let Component = null

  switch (condition.type) {
    case 'WorkflowConditions::AttributesChanged':
      Component = AttributesChangedCondition
      break
    case 'WorkflowConditions::AttributesEqual':
      Component = AttributesEqualCondition
      break
    case 'WorkflowConditions::AttributesMatch':
      Component = AttributesMatchCondition
      break
    case 'WorkflowConditions::MissingAttribute':
      Component = MissingAttributeCondition
      break
    case 'WorkflowConditions::ProblemTicket':
      Component = ProblemCondition
      break
    case 'WorkflowConditions::NoResponse':
      Component = ResponseTimeCondition
      break
    case 'WorkflowConditions::Response':
      Component = ResponseCondition
      break
    case 'WorkflowConditions::PassedSLA':
      Component = SLACondition
      break
    case 'WorkflowConditions::SurveyScore':
      Component = SurveyScoreCondition
      break
    default:
  }

  return (
    <Component
      options={options}
      predicates={condition.predicates}
      update={(key, value) => update(condition, key, value)}
      type={type}
    />
  )
}
